"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuburbanCallbackBannerContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _tracking = require("../../utils/tracking");
var _actionAfterViewedComponent = require("@cian/action-after-viewed-component");
var _useConsultingRequest2 = require("../../hooks/useConsultingRequest");
var _uiKit = require("@cian/ui-kit");
var _SuburbanCallbackBannerMobile = require("../../components/SuburbanCallbackBannerMobile");
var _SuburbanCallbackBanner = require("../../components/SuburbanCallbackBannerTablet/SuburbanCallbackBanner");
var _SuburbanCallbackBanner2 = require("../../components/SuburbanCallbackBannerDesktop/SuburbanCallbackBanner");
var _SuburbanCallbackBannerSuccess = require("../../components/SuburbanCallbackBannerMobile/SuburbanCallbackBannerSuccess");
var _SuburbanCallbackBannerSuccess2 = require("../../components/SuburbanCallbackBannerTablet/SuburbanCallbackBannerSuccess");
var _SuburbanCallbackBannerSuccess3 = require("../../components/SuburbanCallbackBannerDesktop/SuburbanCallbackBannerSuccess");
const _excluded = ["success"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SuburbanCallbackBannerContainer = _ref => {
  let {
    personalAgreementLink,
    defaultPhoneNumber,
    regionId,
    placeType,
    gaLabel,
    userId
  } = _ref;
  const _useConsultingRequest = (0, _useConsultingRequest2.useConsultingRequest)({
      defaultPhoneNumber,
      regionId,
      placeType,
      gaLabel,
      cianSuburbanSaleRefocus: true,
      userId
    }),
    {
      success
    } = _useConsultingRequest,
    bannerProps = (0, _objectWithoutProperties2.default)(_useConsultingRequest, _excluded);
  if (success) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      desktop: true
    }, /*#__PURE__*/React.createElement(_SuburbanCallbackBannerSuccess3.SuburbanCallbackBannerDesktopSuccess, {
      placeType: placeType
    })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      tablet: true
    }, /*#__PURE__*/React.createElement(_SuburbanCallbackBannerSuccess2.SuburbanCallbackBannerTabletSuccess, {
      placeType: placeType
    })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      phone: true
    }, /*#__PURE__*/React.createElement(_SuburbanCallbackBannerSuccess.SuburbanCallbackBanneMobileSuccess, null)));
  }
  return /*#__PURE__*/React.createElement(_actionAfterViewedComponent.ActionAfterViewObserver, {
    callback: _tracking.trackCallbackBannerShow,
    percentVisible: 1,
    triggerOnce: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_SuburbanCallbackBanner2.SuburbanCallbackBannerDesktop, (0, _extends2.default)({}, bannerProps, {
    personalAgreementLink: personalAgreementLink,
    placeType: placeType
  }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true
  }, /*#__PURE__*/React.createElement(_SuburbanCallbackBanner.SuburbanCallbackBannerTablet, (0, _extends2.default)({}, bannerProps, {
    personalAgreementLink: personalAgreementLink,
    placeType: placeType
  }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement(_SuburbanCallbackBannerMobile.SuburbanCallbackBannerMobile, (0, _extends2.default)({}, bannerProps, {
    personalAgreementLink: personalAgreementLink,
    placeType: placeType
  })))));
};
exports.SuburbanCallbackBannerContainer = SuburbanCallbackBannerContainer;